export default __webpack_public_path__ + "static/media/AvatarKids-07.afd9e2ef.png";